module.exports = __webpack_public_path__ + "img/3层技术防护体系.5bbff743.png";